import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rcc-filter"},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('rcc-button',{attrs:{"is-icon":true,"size":"x-small"},on:{"click":function($event){return _vm.$emit('close', _vm.name)}}},[_c(VIcon,{attrs:{"small":""}},[_vm._v("mdi-close")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }